import { Pipe, PipeTransform } from '@angular/core';
import { PeopleService } from '../../services/people.service';
import { Person } from '../../models/person.interface';
import { flatMap } from 'rxjs/operators';

@Pipe({
  name: 'face',
})
export class FacePipe implements PipeTransform {
  constructor(private people: PeopleService) {}

  transform(person: Person) {
    return this.people
      .face(person.personId)
      .pipe(flatMap(({ faceId }) => this.people.photo(faceId)));
  }
}
